import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { claimsHomeRoute, HttpStatus } from 'config/Api.Config';
import useContract from './Contract.Hooks';
import ContractList from './sections/Contract.List';

export const contractIndexRoute = claimsHomeRoute + '/contract/:id?';
export default function ContractIndex() {
  const contractHook = useContract();

  if (!contractHook.hasAccess) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider data={contractHook} render={<ContractList />} />
    </>
  );
}
